__turbopack_context__.v({
  "icon": "styles-module-scss-module__kovj-G__icon",
  "iconWrapper": "styles-module-scss-module__kovj-G__iconWrapper",
  "root": "styles-module-scss-module__kovj-G__root",
  "text": "styles-module-scss-module__kovj-G__text",
});
